import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Button } from 'foundations-components/transitional/components/Button';
import { getSnippetsUrl, getNewSnippetsUrl } from '../../lib/links';
import { H5 } from 'foundations-components/transitional/components/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SnippetPopoverHeader = () => /*#__PURE__*/_jsxs(TFlex, {
  justify: "between",
  align: "center",
  marginBlockEnd: "300",
  children: [/*#__PURE__*/_jsx(H5, {
    marginBlockEnd: "0",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'RichTextLib.snippet.title.insert'
    })
  }), /*#__PURE__*/_jsxs(Box, {
    grow: 0,
    children: [/*#__PURE__*/_jsx(Button, {
      external: true,
      href: getSnippetsUrl(),
      size: "small",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'RichTextLib.snippet.button.manage'
      })
    }), /*#__PURE__*/_jsx(Button, {
      external: true,
      href: getNewSnippetsUrl(),
      size: "small",
      use: "tertiary",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'RichTextLib.snippet.button.createNew'
      })
    })]
  })]
});
export default SnippetPopoverHeader;